import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SearchService } from '../../services/search-service.service';
declare var google: any;
@Component({
  selector: 'app-googlemaps',
  templateUrl: './googlemaps.component.html',
  styleUrls: ['./googlemaps.component.scss'],
})
export class GooglemapsComponent implements OnInit {
  public options: any;
  public overlays: any = [];
  images: any = ['../../assets/images/home-banner-2.jpg'];
  public categoryTypes: any = [];
  public selectedCats: any = [];
  public isFromNearIslands: boolean = false;
  public classifications: string;
  public latestSearchCategories: any = [];
  public isTextFromOutSide: boolean;
  public searchResults: any = [];
  public latLongitude: any = [];
  public lattitude: any = [];
  public longitude: any = [];
  //public map: google.maps.Map;
  public infoWindow: any;
  public productId: string;
  bannerImg = '../../assets/images/home-banner-2.avif';

  activeIndex: any;
  responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5,
    },
    {
      breakpoint: '768px',
      numVisible: 3,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
    },
  ];
  displayCustom: boolean;

  constructor(public searchService: SearchService, private router: Router, private translate: TranslateService) {}
  ngOnInit(): void {
    this.categoryTypes = [
      { id: 'ACCOMM', name: 'Accommodation' },
      { id: 'ATTRACTION', name: 'Attraction' },
      { id: 'DESTINFO', name: 'Destination Information' },
      { id: 'EVENT', name: 'Event' },
      { id: 'RESTAURANT', name: 'Food & Drinks' },
      { id: 'GENSERVICE', name: 'General Service' },
      { id: 'HIRE', name: 'Hire' },
      { id: 'INFO', name: 'Information Services' },
      { id: 'JOURNEY', name: 'Journeys' },
      { id: 'TOUR', name: 'Tour' },
      { id: 'TRANSPORT', name: 'Transport' },
      { id: 'TOUROPERATOR', name: 'Tour Operators' },
    ];
    this.options = {
      center: { lat: -4.6839, lng: 55.4495 },
      zoom: 12,
    };
    this.infoWindow = new google.maps.InfoWindow();
    // this.overlays = [
    //   new google.maps.Marker({position: {lat: -4.6303597, lng: 55.4547767}, title:"Anse Aux Pins"}),
    //   new google.maps.Marker({position: {lat: 4.679574, lng: 55.491977}, title:"Grand Anse"}),
    //   new google.maps.Marker({position: {lat: -4.679574, lng: 55.491977}, title:"Anse Reunion"}),
    //   new google.maps.Polygon({paths: [
    //       {lat: -4.6303597, lng: 55.4547767},{lat: 4.679574, lng: 55.491977},{lat: -4.679574, lng: 55.491977},{lat: 36.9177, lng: 30.8159}
    //   ], strokeOpacity: 0.5, strokeWeight: 1,fillColor: '#1976D2', fillOpacity: 0.35
    //   }),
    //   new google.maps.Circle({center: {lat: 36.90707, lng: 30.56533}, fillColor: '#1976D2', fillOpacity: 0.35, strokeWeight: 1, radius: 1500}),
    //   new google.maps.Polyline({path: [{lat: 36.86149, lng: 30.63743},{lat: 36.86341, lng: 30.72463}], geodesic: true, strokeColor: '#FF0000', strokeOpacity: 0.5, strokeWeight: 2})
    // ];
  }
  handleOverlayClick(event: any) {
    let title = event.overlay.getTitle();
    if (title) {
      for (var i = 0; i < this.searchResults.length; i++) {
        if (this.searchResults[i].productName == title) {
          this.productId = this.searchResults[i].productId;
        }
      }
      this.infoWindow.setContent(
        '' +
          title +
          '<br><br>' +
          '<a href="/listingdetails/' +
          this.productId +
          '">' +
          this.translate.instant('View Details') +
          '</a>'
      );
      this.infoWindow.open(event.map, event.overlay);
    }
  }
  selectCategeory(categoryType: string) {
    if (!this.isFromNearIslands) {
      var index = this.selectedCats.indexOf(categoryType);
      if (index > -1) {
        this.selectedCats.splice(index, 1);
      } else {
        this.selectedCats.push(categoryType);
      }
      this.classifications = '';
      this.latestSearchCategories;
    }
    this.isTextFromOutSide = false;
    this.searchByValue(this.selectedCats);
    this.isFromNearIslands = false;
  }
  searchByValue(categeoryName: any) {
    this.searchService.getMapsListing(categeoryName).subscribe((data) => {
      this.searchResults = [];
      this.searchResults = data.products;
      this.overlays = [];
      this.searchResults.forEach((el: any) => {
        el.addresses.forEach((ele: any) => {
          el.geo_location = ele.geo_location;
          this.latLongitude = el.geo_location;
          this.latLongitude = this.latLongitude.split(',');
          // if ((this.latLongitude[0] === '') === false && ele.address_type === 'PHYSICAL') {
          this.lattitude = this.latLongitude[0];
          this.longitude = this.latLongitude[1];
          // }
          var referlay = new google.maps.Marker({
            position: { lat: parseFloat(this.lattitude), lng: parseFloat(this.longitude) },
            title: el.productName,
            productId: el.productId,
            catName: el.productCategoryId,
          });
          this.overlays.push(referlay);
        });
      });
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
